import request from 'utils/Httprequest';
const prefixed = '/api/braintrain-service-photon';
export default {
  userList(data) {
    console.log('data111', data)
    return request({
      url: `${prefixed}/ccStudent/relation/selectPage`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  crUserList(data) {
    console.log('data222', data)
    return request({
      url: `${prefixed}/cyStudent/relation/selectPage`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 打电话
  makePhoneCall(data) {
    return request({
      url: `${prefixed}/photon/user/makeCall`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 系统体验课信息查询 
  studentSelectAutoSysCommodity(data) {
    return request({
      url: `${prefixed}/cyStudent/relation/selectAutoSysCommodity`,
      method: 'post',
      json: true,
      data: data,
    });
  },
  // 查看所有课程
  studentSelectAllSub() {
    return request({
      url: `${prefixed}/cyStudent/relation/selectAllSub`,
      method: 'GET',
    });
  },
  // 获取当天还有多少次加好友的机会
  studentCurrentDayCount(data) {
    return request({
      url: `${prefixed}/workbench/apply/currentDayCount?employeeId=${data}`,
      method: 'GET',
    });
  },
  // 反加好友 
  studentAddFriends(data) {
    return request({
      url: `${prefixed}/workbench/apply/addFriends`,
      method: 'post',
      json: true,
      data: data,
    });
  },
};
